import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['María L.', 'Juan C.', 'Luciana G.', 'Martín R.', 'Carolina S.', 'Diego F.', 'Valeria M.', 'Sebastián P.', 'Florencia T.', 'Nicolás B.', 'Andrea V.', 'Pablo H.', 'Romina D.', 'Facundo A.', 'Gabriela N.', 'Alejandro K.', 'Daniela O.', 'Fernando E.', 'Soledad I.', 'Gustavo W.', 'Laura Z.', 'Hernán J.', 'Natalia Q.', 'Rodrigo U.', 'Cecilia X.'];
const cities = ['Ciudad de México', 'Bogotá', 'Lima', 'Santiago', 'Buenos Aires', 'Guadalajara', 'Medellín', 'Monterrey', 'Quito', 'Guayaquil', 'Montevideo', 'Asunción', 'San José', 'Ciudad de Panamá', 'Santo Domingo', 'Córdoba', 'Rosario', 'Cali', 'Arequipa', 'Puebla', 'Valparaíso', 'Barranquilla', 'La Paz'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-382" data-mp="1a1txinet5c29">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-4 z-[60] max-w-xs" data-id="element-383" data-mp="1a2vawyjaqan5">
          <div className="bg-bg-card rounded-[20px] shadow-2xl border border-line p-4 flex items-start gap-3" data-id="element-384" data-mp="1r13keooak30q">
            <div className="w-10 h-10 bg-success/20 rounded-full flex items-center justify-center shrink-0" data-id="element-385" data-mp="1vupohsge2ykx">
              <ShoppingBag size={20} className="text-success" data-id="element-386" data-mp="20uu3fe1nfl91" />
            </div>
            <div data-id="element-387" data-mp="24s9oky2imoty">
              <p className="text-sm font-bold text-txt-primary" data-id="element-388" data-mp="24vxi3x7ynb8o">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-txt-body" data-id="element-389" data-mp="2es0mzau75nzb">
                compró la{' '}
                <span className="font-bold text-brandViolet" data-id="element-390" data-mp="ff4uesz55s0c">
                  Biblioteca del Código de los Chakras
                </span>
              </p>
              <p className="text-xs text-txt-muted mt-1" data-id="element-391" data-mp="kerhrv8ooomv">
                hace {data.minutes} minutos
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-txt-muted hover:text-txt-primary text-xs ml-auto shrink-0 mt-0.5" aria-label="Cerrar notificación" data-id="element-392" data-mp="8407fdy5mpcu">
              ✕
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}